import { CampaignTypeNames, CampaignTypes } from 'features/Codes'

import { MetricColumns } from '../../Columns'

export const FilterOperators = {
  eq: {
    key: 'eq',
    name: '일치',
  },
  same: {
    key: 'eq',
    name: '같음',
  },
  ne: {
    key: 'ne',
  },
  gt: {
    key: 'gt',
    name: '초과',
  },
  goe: {
    key: 'goe',
    name: '이상',
  },
  lt: {
    key: 'lt',
    name: '미만',
  },
  loe: {
    key: 'loe',
    name: '이하',
  },
  in: {
    key: 'in',
  },
  nin: {
    key: 'nin',
  },
  like: {
    key: 'like',
    name: '포함',
  },
  notLike: {
    key: 'notLike',
    name: '제외',
  },
  notNull: {
    key: 'notNull',
  },
  isNull: {
    key: 'isNull',
  },
  none: {
    key: 'none',
  },
}

export const FilterTypes = {
  TEXT: {
    operators: [
      FilterOperators.like,
      FilterOperators.notLike,
      FilterOperators.eq,
    ],
    defaultValue: {
      value: '',
      operator: FilterOperators.like.key,
    },
  },
  NUMBER: {
    operators: [
      FilterOperators.goe,
      FilterOperators.loe,
      FilterOperators.gt,
      FilterOperators.lt,
      FilterOperators.eq,
    ],
    defaultValue: {
      value: '',
      operator: FilterOperators.goe.key,
    },
  },
  CHECKBOX: {
    defaultValue: {
      values: [],
    },
  },
  MULTI: {
    operators: [
      FilterOperators.goe,
      FilterOperators.loe,
      FilterOperators.gt,
      FilterOperators.lt,
      FilterOperators.eq,
    ],
    defaultValue: {
      value: '',
      operator: FilterOperators.goe.key,
      checked: false,
    },
  },
  ID: {
    defaultValue: {
      value: '',
    },
  },
}

const metricMenus = [
  MetricColumns.viewableImpression,
  MetricColumns.click,
  MetricColumns.ctr,
  MetricColumns.spending,
  MetricColumns.renderedImpression,
  MetricColumns.ppc,
  MetricColumns.rank,
  MetricColumns.costPerImp,
  MetricColumns.convAppInstall7d,
  MetricColumns.convCmptReg7d,
  MetricColumns.convViewCart7d,
  MetricColumns.convPurchase7d,
  MetricColumns.convPurchaseP7d,
  MetricColumns.convParticipation7d,
  MetricColumns.convSignup7d,
  MetricColumns.convAppInstall1d,
  MetricColumns.convCmptReg1d,
  MetricColumns.convViewCart1d,
  MetricColumns.convPurchase1d,
  MetricColumns.convPurchaseP1d,
  MetricColumns.convParticipation1d,
  MetricColumns.convSignup1d,
  MetricColumns.convKfPfAdd7d,
  MetricColumns.costPerConvKfPfAdd7d,
  MetricColumns.convKfPfAdd7dRate,
  MetricColumns.convKfPfAdd1d,
  MetricColumns.costPerConvKfPfAdd1d,
  MetricColumns.convKfPfAdd1dRate,
].map(({ name, displayName }) => ({
  key: name,
  title: displayName,
  filterType: FilterTypes.NUMBER,
}))

export const FilterMenus = {
  recent: {
    title: '최근 검색한 조건',
  },
  saved: {
    title: '저장한 검색 조건',
  },
  campaign: {
    domain: 'campaign',
    title: '캠페인',
    subs: [
      {
        key: 'type',
        title: '캠페인 유형',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'name',
        title: '캠페인 이름',
        filterType: FilterTypes.TEXT,
      },
      {
        key: 'id',
        title: '캠페인 ID',
        filterType: FilterTypes.ID,
      },
      {
        key: 'status',
        title: 'ON/OFF',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'operation',
        title: '운영상태',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'bizChannels',
        title: '비즈채널',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'trackers',
        title: '전환추적',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'traceUrl',
        title: '추적URL',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'dailyBudget',
        title: '일예산',
        filterType: FilterTypes.MULTI,
      },
      ...metricMenus,
    ],
  },
  adGroup: {
    domain: 'adGroup',
    title: '광고그룹',
    subs: [
      {
        key: 'name',
        title: '광고그룹 이름',
        filterType: FilterTypes.TEXT,
      },
      {
        key: 'id',
        title: '광고그룹 ID',
        filterType: FilterTypes.ID,
      },
      {
        key: 'status',
        title: 'ON/OFF',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'operation',
        title: '운영상태',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'placementCategories',
        title: '매체유형',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'deviceTypes',
        title: '디바이스',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'keywordExtensionYn',
        title: '키워드확장',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'maxBiddingAmount',
        title: '기본입찰가',
        filterType: FilterTypes.NUMBER,
      },
      {
        key: 'dailyBudget',
        title: '일예산',
        filterType: FilterTypes.NUMBER,
      },
      {
        key: 'mobileWeight',
        title: '입찰가중치 모바일',
        filterType: FilterTypes.NUMBER,
      },
      {
        key: 'pcWeight',
        title: '입찰가중치 PC',
        filterType: FilterTypes.NUMBER,
      },
      {
        key: 'keywordExtensionWeight',
        title: '입찰가중치 키워드확장',
        filterType: FilterTypes.NUMBER,
      },
      {
        key: 'contentMatchingMaxBiddingAmount',
        title: '콘텐츠 매체 입찰가',
        filterType: FilterTypes.MULTI,
      },
      {
        key: 'segmentKeywordYn',
        title: '분절 키워드',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'impressionScheduleEndDate',
        title: '집행일자 종료일 설정',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'impressionScheduleWeeklySchedule',
        title: '집행요일/시간 설정',
        filterType: FilterTypes.CHECKBOX,
      },
      ...metricMenus,
    ],
  },
  keyword: {
    domain: 'keyword',
    title: '키워드',
    subs: [
      {
        key: 'text',
        title: '키워드',
        filterType: FilterTypes.TEXT,
      },
      {
        key: 'id',
        title: '키워드 ID',
        filterType: FilterTypes.ID,
      },
      {
        key: 'status',
        title: 'ON/OFF',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'operation',
        title: '운영상태',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'reviewStatus',
        title: '심사상태',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'maxBiddingAmount',
        title: '키워드입찰가',
        filterType: FilterTypes.MULTI,
      },
      {
        key: 'qi',
        title: '품질지수',
        filterType: FilterTypes.NUMBER,
      },
      {
        key: 'landingUrlYn',
        title: '랜딩 URL',
        filterType: FilterTypes.CHECKBOX,
      },
      ...metricMenus,
    ],
  },
  creativeLink: {
    domain: 'creativeLink',
    title: '소재',
    subs: [
      {
        key: 'name',
        title: '소재 이름',
        filterType: FilterTypes.TEXT,
      },
      {
        key: 'id',
        title: '소재연결 ID',
        filterType: FilterTypes.ID,
      },
      {
        key: 'creatives',
        title: '소재 ID',
        filterType: FilterTypes.ID,
      },
      {
        key: 'status',
        title: 'ON/OFF',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'operation',
        title: '운영상태',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'reviewStatus',
        title: '심사상태',
        filterType: FilterTypes.CHECKBOX,
      },
      {
        key: 'asset',
        title: '확장소재 유형',
        filterType: FilterTypes.CHECKBOX,
      },
      ...metricMenus,
    ],
  },
}

export const OperationValues = {
  campaign: [
    {
      id: 'OPERABLE',
      name: '운영가능',
    },
    {
      id: 'NOT_OPERABLE_CAMPAIGN_OFF',
      name: '운영 불가(캠페인 OFF)',
    },
    {
      id: 'NOT_OPERABLE_CAMPAIGN_DAILY_BUDGET_EXCEED',
      name: '운영 불가(캠페인 일예산 초과)',
    },
    {
      id: 'NOT_OPERABLE_BIZCHANNEL_ADMIN_STOP',
      name: '운영 불가(비즈채널 관리자정지)',
    },
    {
      id: 'NOT_OPERABLE_BIZCHANNEL_REVIEW_NOT_APPROVED',
      name: '운영 불가(비즈채널 심사 미승인)',
    },
    {
      id: 'NOT_OPERABLE_TALK_BIZCHANNEL',
      name: '운영 불가(톡채널 조회불가)',
    },
  ],
  adGroup: [
    {
      id: 'OPERABLE',
      name: '운영가능',
    },
    {
      id: 'NOT_OPERABLE_ADGROUP_OFF',
      name: '운영 불가(광고그룹 OFF)',
    },
    {
      id: 'NOT_OPERABLE_ADGROUP_DAILY_BUDGET_EXCEED',
      name: '운영 불가(광고그룹 일예산 초과)',
    },
    {
      id: 'NOT_OPERABLE_ADGROUP_DATE',
      name: '운영 불가(광고그룹 미노출 기간)',
    },
    {
      id: 'NOT_OPERABLE_ADGROUP_HOUR',
      name: '운영 불가(광고그룹 미노출 시간)',
    },
    {
      id: 'NOT_OPERABLE_ADGROUP_WEEKLY_DAY',
      name: '운영 불가(광고그룹 미노출 요일)',
    },
  ],
  keyword: [
    {
      id: 'OPERABLE',
      name: '운영가능',
    },
    {
      id: 'NOT_OPERABLE_KEYWORD_OFF',
      name: '운영 불가(키워드 OFF)',
    },
    {
      id: 'NOT_OPERABLE_KEYWORD_REVIEW_NOT_APPROVED',
      name: '운영 불가(키워드 심사 미승인)',
    },
  ],
  creativeLink: [
    {
      id: 'OPERABLE',
      name: '운영가능',
    },
    {
      id: 'NOT_OPERABLE_CREATIVE_OFF',
      name: '운영 불가(소재 OFF)',
    },
    {
      id: 'NOT_OPERABLE_CREATIVE_REVIEW_NOT_APPROVED',
      name: '운영 불가(소재 심사 미승인)',
    },
  ],
}

export const ReviewStatusValues = {
  keyword: [
    {
      id: 'APPROVED',
      name: '심사승인',
    },
    {
      id: 'KEYWORD_APPROVING',
      name: '키워드 심사중',
    },
    {
      id: 'KEYWORD_REJECTED',
      name: '키워드 심사보류',
    },
    {
      id: 'LANDING_URL_APPROVING',
      name: '랜딩 URL 심사중',
    },
    {
      id: 'LANDING_URL_REJECTED',
      name: '랜딩 URL 심사보류',
    },
  ],
  creativeLink: [
    {
      id: 'APPROVED',
      name: '심사승인',
    },
    {
      id: 'APPROVING',
      name: '심사중',
    },
    {
      id: 'REJECTED_APPROVAL',
      name: '심사보류',
    },
  ],
}

export const CheckboxValues = {
  type: [
    {
      id: CampaignTypes.PREMIUM_LINK,
      name: CampaignTypeNames[CampaignTypes.PREMIUM_LINK],
    },
    {
      id: CampaignTypes.TALK_CHANNEL,
      name: CampaignTypeNames[CampaignTypes.TALK_CHANNEL],
    },
  ],
  status: [
    {
      id: 'ON',
      name: 'ON',
    },
    {
      id: 'OFF',
      name: 'OFF',
    },
  ],
  traceUrl: [
    {
      id: 'Y',
      name: '설정',
    },
    {
      id: 'N',
      name: '미설정',
    },
  ],
  placementCategories: [
    {
      id: 'PREMIUM_LINK_SEARCH_KAKAO',
      name: '검색 매체 카카오',
    },
    {
      id: 'PREMIUM_LINK_SEARCH_PARTNER',
      name: '검색 매체 파트너',
    },
    {
      id: 'PREMIUM_LINK_CONTENT_KAKAO',
      name: '콘텐츠 매체 카카오',
    },
    {
      id: 'PREMIUM_LINK_CONTENT_PARTNER',
      name: '콘텐츠 매체 파트너',
    },
  ],
  deviceTypes: [
    {
      id: 'MOBILE',
      name: '모바일',
    },
    {
      id: 'PC',
      name: 'PC',
    },
  ],
  keywordExtensionYn: [
    {
      id: 'Y',
      name: '설정',
    },
    {
      id: 'N',
      name: '미설정',
    },
  ],
  impressionScheduleEndDate: [
    {
      id: 'Y',
      name: '설정',
    },
    {
      id: 'N',
      name: '미설정',
    },
  ],
  impressionScheduleWeeklySchedule: [
    {
      id: 'Y',
      name: '설정',
    },
    {
      id: 'N',
      name: '미설정',
    },
  ],
  landingUrlYn: [
    {
      id: 'Y',
      name: '설정',
    },
    {
      id: 'N',
      name: '미설정',
    },
  ],
  asset: [
    {
      id: 'IMAGE',
      name: '이미지형',
    },
    {
      id: 'TEXT',
      name: '텍스트형',
    },
    {
      id: 'BUTTON',
      name: '버튼형',
    },
    {
      id: 'LINK',
      name: '연동형',
    },
  ],
  segmentKeywordYn: [
    {
      id: 'Y',
      name: '설정',
    },
    {
      id: 'N',
      name: '미설정',
    },
  ],
}

export const DELETED = {
  id: 'DELETED',
  name: '삭제',
}

export const getOperatorName = (operator, filterType) =>
  operator.key === 'eq' &&
  (filterType === FilterTypes.NUMBER || filterType === FilterTypes.MULTI)
    ? '같음'
    : operator.name

export const CheckboxSpecs = {
  dailyBudget: {
    key: 'dailyBudget',
    dimension: 'dailyBudgetYn',
    text: '미설정',
  },
  contentMatchingMaxBiddingAmount: {
    key: 'contentMatchingMaxBiddingAmount',
    dimension: 'customContentMatchingMaxBiddingAmountYn',
    text: '미설정',
  },
  maxBiddingAmount: {
    key: 'maxBiddingAmount',
    dimension: 'biddingStrategyType',
    text: '광고그룹 입찰가 포함',
  },
}

export const AllowFloatKeys = [
  MetricColumns.spending.name,
  MetricColumns.ctr.name,
  MetricColumns.ppc.name,
  MetricColumns.costPerImp.name,
  MetricColumns.convKfPfAdd7dRate.name,
  MetricColumns.convKfPfAdd1dRate.name,
]
